import { getPickListCode, PICKLIST_CROPPING_SEASON } from "~/core/picklist/picklist-names";

export const dropdowns = {};

export const picklists = {
    [PICKLIST_CROPPING_SEASON]: getPickListCode(PICKLIST_CROPPING_SEASON),
};
